import Hero from './Hero'

export * from './Hero'

export default Hero
